import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-752a96fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switching" }
const _hoisted_2 = { class: "spinner-box mt-4" }

import Modal from '@/popup/components/shared/Modal/Modal'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkSwitch',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "p-6",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, { class: "wider" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$t('modal.network_switch.switching')) + " ", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SvgIcon, {
                class: "spinner",
                name: "progress",
                color: "var(--neutral-20)",
                width: "40",
                height: "40"
              })
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})